<template>
  <WaterMarkNew
    class="watermark"
    :width="wmImage ? wmImageWidth : width"
    :height="wmImage ? wmImageHeight : null"
    :content="content"
    :image="wmImage"
    :font="{
      ...font,
      textAlign: 'center',
      fontWeight: 400,
      textBaseline: isFirefox() ? 'top' : 'hanging'
    }"
    :zIndex="zIndex"
    :rotate="rotate"
    :gap="gapRel"
    :offset="offset"
  >
    <slot />
    <slotInstance></slotInstance>
  </WaterMarkNew>
</template>
<script setup lang="ts">
import html2canvas from 'html2canvas'
import { computed, useSlots, type Slots, defineComponent } from 'vue'
import WaterMarkNew from './WaterMarkComp'
import { debounce } from 'lodash-es'
// const show = ref(!document.location.href.includes('showmark'))
const props = defineProps({
  content: {
    type: String,
    default: ' '
  },
  useSlot: {
    type: Boolean,
    default: false
  },
  hide: {
    type: Boolean,
    default: false
  },
  height: {
    type: Number,
    default: 64
  },
  width: {
    type: Number,
    default: 150
  },
  rotate: {
    type: Number,
    default: 15
  },
  font: {
    type: Object,
    default: {}
  },
  zIndex: {
    type: Number,
    default: 50000
  },
  gap: {
    type: Array,
    default: [100, 100]
  },
  offset: {
    type: Array,
    default: [0, 0]
  },
  wmLevel: {
    type: Number,
    default: 2
  }
})

const oldWmImage = ref('')
const wmImage = ref('')
const wmImageWidth = ref(150)
const wmImageHeight = ref(30)
const customSlotDom = ref<HTMLElement | null>(null)

const emptyImg =
  'https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mdm/touming-409a75f9.png'

const slots = useSlots()

const createSlot = (slots: Readonly<Slots>) => {
  return defineComponent({
    setup() {
      if (slots?.custom) {
        return () => slots?.custom()?.[0]
      }
      return () => {}
    },
    mounted() {
      initWm(this.$el)
    },
    updated() {
      initWm(this.$el)
    }
  })
}
const slotInstance = props.useSlot ? createSlot(slots) : h('div')

onMounted(async () => {
  // html2canvasFun()
})

const initWm = debounce(($el) => {
  console.log('更新 标志')
  const elInnerHTML = $el?.innerHTML || ''
  const slotInnerHTML = customSlotDom.value?.innerHTML || ''

  customSlotDom.value = $el

  // 相同不做处理
  if (elInnerHTML === slotInnerHTML && wmImage.value && wmImage.value !== emptyImg) {
    return
  }

  if (!elInnerHTML && !wmImage.value) {
    return
  }

  if (!elInnerHTML) {
    console.log('closeImgWm')

    closeImgWm()
  } else {
    console.log('showImgWm')
    // wmImage.value = oldWmImage.value || wmImage.value

    if (
      elInnerHTML === slotInnerHTML &&
      (oldWmImage.value || wmImage.value) &&
      wmImage.value !== emptyImg
    ) {
      wmImage.value = oldWmImage.value || wmImage.value
      return
    }

    html2canvasFun()
  }
}, 300)

// 关闭水印 透明图
const closeImgWm = async () => {
  // hideImgWm.value = true

  wmImage.value = emptyImg
}

const checkSlotContent = () => {
  if (!customSlotDom.value?.innerHTML) {
    return false
  }
  return true
}

const html2canvasFun = debounce(async () => {
  if (!checkSlotContent() || !customSlotDom.value) {
    return
  }
  const r = await html2canvas(customSlotDom.value, {
    backgroundColor: null,
    scale: 4, //提升清晰度
    useCORS: true,
    logging: false,
    dpi: window.devicePixelRatio * 4
  })
  // const image = new Image()
  const imgUrl = r.toDataURL('image/png')
  // image.src = imgUrl
  // console.log(image)
  wmImage.value = imgUrl
  wmImageWidth.value = r.width / 4 || 150
  wmImageHeight.value = r.height / 4 || 150
  oldWmImage.value = imgUrl
}, 500)

const isFirefox = () => {
  return /firefox/i.test(navigator.userAgent)
}

const gapRel = computed(() => {
  if (props.wmLevel === 3) {
    return [40, 80] //[0, 25]
  } else if (props.wmLevel === 2) {
    return [80, 160] //[50, 50]
  } else if (props.wmLevel === 1) {
    return [120, 200] //[150, 100]
  }
  return [100, 50]
})
</script>
<style lang="scss" scoped>
.watermark {
  height: 100%;
}
</style>
